import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import internTestApi from "../../api/serviceApi/internTestApi";

const getDeviceFingerprint = () => {
  const data = [
    navigator.userAgent,
    navigator.language,
    screen.width,
    screen.height,
    navigator.platform
  ].join("|");

  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    hash = (hash << 5) - hash + data.charCodeAt(i);
    hash |= 0;
  }
  return `fp_${Math.abs(hash)}`;
};

export default function TestLanding() {
  const { testId } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: "", email: "", college: "" });

  const isValidEmail = email =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleStart = async () => {
    if (!form.name || !form.email || !form.college) {
      alert("All fields are mandatory");
      return;
    }

    if (!isValidEmail(form.email)) {
      alert("Enter valid email");
      return;
    }

    try {
      const res = await internTestApi.post("api/intern-test/start-attempt", {
        testId,
        ...form,
        deviceFingerprint: getDeviceFingerprint()
      });

      sessionStorage.setItem("attemptId", res.data.attemptId);
      navigate(`/intern-test/${testId}/exam`, { replace: true });

    } catch (err) {
      alert(err.response?.data?.message || "Cannot start test");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded shadow max-w-md w-full">
        <h2 className="text-xl font-bold mb-6 text-center">
          Intern Assessment
        </h2>

        {["name", "email", "college"].map(field => (
          <input
            key={field}
            className="w-full border p-2 mb-4 rounded"
            placeholder={field[0].toUpperCase() + field.slice(1)}
            value={form[field]}
            onChange={e =>
              setForm({ ...form, [field]: e.target.value })
            }
          />
        ))}

        <button
          onClick={handleStart}
          className="w-full bg-black text-white py-2 rounded"
        >
          Start Test →
        </button>
      </div>
    </div>
  );
}
